/**
 * أنواع التخفيضات المتاحة
 */
export enum DiscountType {
  PERCENTAGE = 'percentage', // نسبة مئوية
  FIXED_AMOUNT = 'fixed_amount', // مبلغ ثابت
  BUY_X_GET_Y = 'buy_x_get_y', // اشتر X واحصل على Y
  BUNDLE = 'bundle' // حزمة منتجات بسعر خاص
}

/**
 * حالة العرض
 */
export enum PromotionStatus {
  ACTIVE = 'active', // نشط
  SCHEDULED = 'scheduled', // مجدول
  EXPIRED = 'expired', // منتهي
  DRAFT = 'draft' // مسودة
}

/**
 * نطاق تطبيق العرض
 */
export enum PromotionScope {
  PRODUCT = 'product', // منتج محدد
  CATEGORY = 'category', // فئة محددة
  ALL = 'all' // جميع المنتجات
}

/**
 * شروط الكمية للعرض
 */
export interface QuantityCondition {
  minQuantity: number; // الحد الأدنى للكمية
  maxQuantity?: number; // الحد الأقصى للكمية (اختياري)
}

/**
 * شروط العرض للمنتجات
 */
export interface PromotionCondition {
  productIds?: string[]; // معرفات المنتجات المشمولة في العرض
  categoryIds?: string[]; // معرفات الفئات المشمولة في العرض
  minOrderAmount?: number; // الحد الأدنى لمبلغ الطلب
  quantityConditions?: QuantityCondition[]; // شروط الكمية
}

/**
 * قيمة التخفيض
 */
export interface DiscountValue {
  value: number; // قيمة التخفيض
  maxDiscount?: number; // الحد الأقصى للتخفيض (للنسبة المئوية)
}

/**
 * تفاصيل عرض اشتر X واحصل على Y
 */
export interface BuyXGetYDetails {
  buyQuantity: number; // كمية الشراء
  getQuantity: number; // كمية الهدية
  getProductId?: string; // معرف المنتج الهدية (إذا كان مختلفًا)
}

/**
 * تفاصيل عرض الحزمة
 */
export interface BundleDetails {
  productIds: string[]; // معرفات المنتجات في الحزمة
  bundlePrice: number; // سعر الحزمة
}

/**
 * نموذج بيانات العرض
 */
export interface Promotion {
  id: string;
  title: string; // عنوان العرض
  description: string; // وصف العرض
  imageUrl?: string; // صورة العرض
  startDate: Date | string; // تاريخ بدء العرض
  endDate: Date | string; // تاريخ انتهاء العرض
  status: PromotionStatus; // حالة العرض
  scope: PromotionScope; // نطاق تطبيق العرض
  discountType: DiscountType; // نوع التخفيض
  discountValue: DiscountValue; // قيمة التخفيض
  conditions: PromotionCondition; // شروط العرض
  buyXGetYDetails?: BuyXGetYDetails; // تفاصيل عرض اشتر X واحصل على Y
  bundleDetails?: BundleDetails; // تفاصيل عرض الحزمة
  usageLimit?: number; // الحد الأقصى لاستخدام العرض
  usageCount: number; // عدد مرات استخدام العرض
  priority: number; // أولوية العرض (للعروض المتداخلة)
  isActive: boolean; // هل العرض نشط
  showInOffers: boolean; // هل يظهر في صفحة العروض
  createdAt: Date | string; // تاريخ إنشاء العرض
  updatedAt: Date | string; // تاريخ تحديث العرض
}

/**
 * نموذج بيانات إنشاء عرض جديد
 */
export interface CreatePromotionData {
  title: string;
  description: string;
  imageUrl?: string;
  startDate: Date | string;
  endDate: Date | string;
  status: PromotionStatus;
  scope: PromotionScope;
  discountType: DiscountType;
  discountValue: DiscountValue;
  conditions: PromotionCondition;
  buyXGetYDetails?: BuyXGetYDetails;
  bundleDetails?: BundleDetails;
  usageLimit?: number;
  priority: number;
  isActive: boolean;
  showInOffers: boolean;
}

/**
 * نموذج بيانات تحديث عرض
 */
export interface UpdatePromotionData {
  title?: string;
  description?: string;
  imageUrl?: string;
  startDate?: Date | string;
  endDate?: Date | string;
  status?: PromotionStatus;
  scope?: PromotionScope;
  discountType?: DiscountType;
  discountValue?: DiscountValue;
  conditions?: PromotionCondition;
  buyXGetYDetails?: BuyXGetYDetails;
  bundleDetails?: BundleDetails;
  usageLimit?: number;
  priority?: number;
  isActive?: boolean;
  showInOffers?: boolean;
}

/**
 * نموذج بيانات التخفيض المطبق على المنتج
 */
export interface ProductDiscount {
  promotionId: string; // معرف العرض
  discountType: DiscountType; // نوع التخفيض
  discountValue: number; // قيمة التخفيض
  originalPrice: number; // السعر الأصلي
  finalPrice: number; // السعر النهائي بعد التخفيض
  quantityCondition?: QuantityCondition; // شرط الكمية إن وجد
}
